export default "__VITE_ASSET__BY1QbU8F__"